import React from "react";
import Ingredient from "../Ingredient";
import whole from "../../assets/images/ingredients/Cheese_block.png";
import sliced from "../../assets/images/ingredients/SlicedCheese.png";

const Cheese = ({ onClick, changeable=true, changed, hideable=true }) => {
    const handleClick = (event) => {
        event.stopPropagation();
        if (onClick) {
            onClick(event);
        }
    };
    return (
        <Ingredient
            name="Cheese"
            image={[whole, sliced]}
            changeable={changeable}
            changed={changed}
            hideable={hideable}
            onClick={handleClick}
        />
    );
};

export default Cheese;